// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"h5-z","categoryName":"i5-z","categoryImage":"j5-z","categoryContent":"k5-z","bottomAligned":"l5-z"};